import { render, staticRenderFns } from "./LoginBetterUser.vue?vue&type=template&id=f5d5e226&scoped=true&"
import script from "./LoginBetterUser.vue?vue&type=script&lang=js&"
export * from "./LoginBetterUser.vue?vue&type=script&lang=js&"
import style0 from "./LoginBetterUser.vue?vue&type=style&index=0&id=f5d5e226&prod&scoped=true&lang=css&"
import style1 from "./LoginBetterUser.vue?vue&type=style&index=1&id=f5d5e226&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f5d5e226",
  null
  
)

export default component.exports